// extracted by mini-css-extract-plugin
export default {"wrapper":"G4-z","play":"H4-z"};